import { useMemo } from 'react'
import { useCurrentOrganization } from './use-current-organization'
import { useIsSuperAdmin } from './use-permissions'

const PERFORMANCE_HOME_ORGANIZATION_SLUGS: ReadonlySet<string> = new Set([
  'treinta',
  'belo',
  'https://manduhr.com/',
])

const CMOH_ORGANIZATION_SLUG = 'cmoh'

const CMOH_ORGANIZATION_IDS: ReadonlySet<string> = new Set([
  'd67c0877-8959-4435-9d82-ad83f9c0e68e', // CMOh
])

export function useOrganizationFeatureFlags() {
  const { organization, isLoading } = useCurrentOrganization()
  const isSuperAdmin = useIsSuperAdmin()

  const isDataModuleEnabled = organization?.aiVisibility != null

  const isPerformanceHomeEnabled = useMemo(() => {
    if (isSuperAdmin) return true
    if (!organization) return false

    const slug = organization.slug?.toLowerCase()
    return !!slug && PERFORMANCE_HOME_ORGANIZATION_SLUGS.has(slug)
  }, [organization, isSuperAdmin])

  const isCmohWorkspaceEnabled = useMemo(() => {
    if (!organization) return false

    const slug = organization.slug?.toLowerCase()
    return (
      CMOH_ORGANIZATION_IDS.has(organization.id) ||
      slug === CMOH_ORGANIZATION_SLUG
    )
  }, [organization])

  return {
    isDataModuleEnabled,
    isPerformanceHomeEnabled,
    isCmohWorkspaceEnabled,
    isLoadingOrganizationFeatureFlags: isLoading,
  }
}
